module.exports = __webpack_public_path__ + "static/covers-collage_alt-bb8bf12239def868dd300e66624c1042.jpg";